<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h3 class="panel-title">
        Session Type Breakdown
        <CalculationTooltip text="Breakdown of completed sessions by their session type (e.g., Drive, Road Test)." />
      </h3>
    </div>
    <div class="panel-body">
      <DoughnutChart v-if="chartData" :data="chartData" :options="chartOptions" />
    </div>
  </div>
</template>

<script>
import { Doughnut as DoughnutChart } from 'vue-chartjs';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';
import CalculationTooltip from './CalculationTooltip.vue';

ChartJS.register(ArcElement, Tooltip, Legend);

var COLORS = [
  '#337ab7', '#5cb85c', '#f0ad4e', '#d9534f',
  '#5bc0de', '#777', '#9b59b6', '#e67e22'
];

export default {
  name: 'SessionTypesChart',
  components: { DoughnutChart, CalculationTooltip },
  props: {
    sessionTypes: { type: Array, required: true }
  },
  computed: {
    chartData() {
      if (!this.sessionTypes || this.sessionTypes.length === 0) return null;
      return {
        labels: this.sessionTypes.map(function(d) { return d.type_name; }),
        datasets: [{
          data: this.sessionTypes.map(function(d) { return d.sessions; }),
          backgroundColor: COLORS.slice(0, this.sessionTypes.length)
        }]
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: { position: 'right' }
        }
      };
    }
  }
};
</script>
